export const LIMIAR_ARRASTE_RESPOSTA = 56;
export const ARRASTE_MAXIMO = 80;
export const TEMPO_TOQUE_LONGO = 450;
export const LIMITE_TEXTO = 700;
export const CORTE_TEXTO = 520;
export const ICONE_BOTAO_TEMPLATE: Record<string, string> = {
  URL: 'open_in_new',
  PHONE_NUMBER: 'call'
};
export const ICONE_BOTAO_TEMPLATE_PADRAO = 'reply';
